import cookies from 'js-cookie'

export default function handler() {

	if(process.env.VUE_APP_ENV === 'development') {
	
		cookies.remove('token', {
			expires: 365
		})
	
	} else {
	
		cookies.remove('token', {
			domain: (process.env.VUE_APP_TYPE === 'externaldomain') ? window.location.hostname : ".geekgroup.app",
			path: "/",
			expires: 365,
			secure: true,
			sameSite: "None"
		})
	
	}

	window.location.reload()

}